import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { useAppContext } from "../../../../../../context";
import { CellContentRoot } from "../../../../../LightTable";
import { ConstantFormat } from "../../../../../../utils/DateFns";

const RegisteredAtCellContent: React.FC<RegisteredAtCellContent.Props> = ({
	item,
}) => {
	const { dateFns } = useAppContext();

	const content = useMemo(
		() =>
			item.createdAt
				? dateFns.formatTime(item.createdAt, {
						formatTime: ConstantFormat.MDY_UK,
				  })
				: "",
		[dateFns, item.createdAt],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace RegisteredAtCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default RegisteredAtCellContent;
